import React from "react";

class ClientForm extends React.Component {
  render() {
    return <div></div>;
  }
}

export default ClientForm;
